const formPlanum = [
	"",
	"oval",
	"rund",
	"eckig",
	"rechteckig",
	"quadratisch",
	"birnenfoermig",
	"amorph",
	"trapezfoermig",
	"linear",
	"sonstige"
]

export default formPlanum;
